import { render, staticRenderFns } from "./EmploymentData.vue?vue&type=template&id=67035a18&scoped=true"
import script from "./EmploymentData.vue?vue&type=script&lang=js"
export * from "./EmploymentData.vue?vue&type=script&lang=js"
import style0 from "./EmploymentData.vue?vue&type=style&index=0&id=67035a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67035a18",
  null
  
)

export default component.exports